import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(3)
  },
  title: {
    marginBottom: theme.spacing(2)
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  metrics: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: theme.spacing(2)
  },
  metric: {
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5)
  },
  metricLabel: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary
  },
  metricValue: {
    fontSize: '1.25rem',
    fontWeight: 500
  }
}));

const ExecutiveSummary = ({ content, metrics = {} }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        Executive Summary
      </Typography>
      <Box className={classes.content}>
        <Typography variant="body1">
          {content}
        </Typography>
        {Object.keys(metrics).length > 0 && (
          <Box className={classes.metrics}>
            {Object.entries(metrics).map(([key, value]) => (
              <Box 
                key={key} 
                className={classes.metric}
                role="listitem"
                aria-label={`${key}: ${value}`}
              >
                <Typography className={classes.metricLabel}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </Typography>
                <Typography className={classes.metricValue}>
                  {value}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Paper>
  );
};

ExecutiveSummary.propTypes = {
  content: PropTypes.string.isRequired,
  metrics: PropTypes.shape({
    [PropTypes.string]: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ])
  })
};

ExecutiveSummary.defaultProps = {
  metrics: {}
};

export default ExecutiveSummary; 